import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ClipLoader } from 'react-spinners';
import Swal from 'sweetalert2';
import { Col, Row, Radio } from 'antd';
import { useFormik } from 'formik';
import { IoMdArrowBack, IoMdHelpCircle } from 'react-icons/io';

import history from '~/services/history';

import { useDispatch, useSelector } from 'react-redux';
import * as actions from '~/store/modules/careLines/actions';

import {
  dependencia,
  conveniosPaciente,
  comorbidades,
  internacaoEPolitrauma,
  dataEHoraChegada,
  dataEHoraAdmissao,
  dataEHoraIncisao,
  dataEHoraAntibiotico,
  profilaxiaECoagulacao,
  dataEHoraMomentoSentar,
  dataEHoraMomentoDeambular,
  dataEHoraSaida,
  covidQuadril,
  motivoSaida,
  confortoPaliativo,
  pacienteReinternou,
  apresentouInfeccao,
  seguimentoReinternacao,
  reinternacaoQuadril,
  dataDiagnostico,
} from './options';

import Breadcumbs from '~/components/Breadcumbs';
import ErrorField from '~/components/ErrorField';

import { LcQuadrilSchema } from '~/utils/schemas/lcQuadrilSchema';
import { onlyNumbers, scrollPageTo } from '~/helpers/generalFunctions';

import {
  PageTitle,
  BoxContent,
  Content,
  TitleSection,
  BoxInput,
  Label,
  BoxRadios,
  ButtonBox,
  BoxForm,
} from '../styles/style';

import { Input } from '~/components/Input';
import { RadioInput, RadioInputFlex } from '../components/RadioInput';

import { modalConfirm } from '../../LinhasDeCuidadoFormulario/dados/optionsModal';
import { toast } from 'react-toastify';
import DadoFaltantes from '../components/DadosFaltantes';
import ButtonBack from '~/components/ButtonBack';
import ButtonReset from '../components/ButtonReset';
import ExceptionsForm from '../components/ExceptionsForm';
import { getTitleIndicador } from '../careLinesInfo';

const FichadeColetaQuadril = ({ location }) => {
  const dispath = useDispatch();

  const { id } = location?.state;

  const { careLineData, loading, errorData } = useSelector(
    state => state.careLines
  );

  const firstFocus = useRef(null);
  const [numeroPaciente, setNumeroPaciente] = useState('');

  const [dados, setDados] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      num_registro_quadril: dados?.num_registro_quadril?.toString() || null,
      sexo_quadril: dados?.sexo_quadril?.toString() || null,
      dn_quadril: dados?.dn_quadril?.toString() || null,
      convenio_quadril: dados?.convenio_quadril?.toString() || null,
      iam_quadril: dados?.iam_quadril?.toString() || null,
      ic_quadril: dados?.ic_quadril?.toString() || null,
      dvp_quadril: dados?.dvp_quadril?.toString() || null,
      avc_ait_quadril: dados?.avc_ait_quadril?.toString() || null,
      demencia_quadril: dados?.demencia_quadril?.toString() || null,
      dpoc_quadril: dados?.dpoc_quadril?.toString() || null,
      dtc_quadril: dados?.dtc_quadril?.toString() || null,
      hepatica_quadril: dados?.hepatica_quadril?.toString() || null,
      dm_quadril: dados?.dm_quadril?.toString() || null,
      drc_quadril: dados?.drc_quadril?.toString() || null,
      tumor_quadril: dados?.tumor_quadril?.toString() || null,
      leucemia_quadril: dados?.leucemia_quadril?.toString() || null,
      linfoma_quadril: dados?.linfoma_quadril?.toString() || null,
      aids_quadril: dados?.aids_quadril?.toString() || null,
      hoos_quadril: dados?.hoos_quadril?.toString() || null,
      dependencia_quadril: dados?.dependencia_quadril?.toString() || null,
      meem_quadril: dados?.meem_quadril?.toString() || null,
      escolaridade_quadril: dados?.escolaridade_quadril?.toString() || null,
      internacao_quadril: dados?.internacao_quadril?.toString() || null,
      politrauma_quadril: dados?.politrauma_quadril?.toString() || null,
      entrada_data_quadril: dados?.entrada_data_quadril?.toString() || null,
      entrada_hora_quadril: dados?.entrada_hora_quadril?.toString() || null,
      admissao_data_quadril: dados?.admissao_data_quadril?.toString() || null,
      admissao_hora_quadril: dados?.admissao_hora_quadril?.toString() || null,
      antibiotico_data_quadril:
        dados?.antibiotico_data_quadril?.toString() || null,
      antibiotico_hora_quadril:
        dados?.antibiotico_hora_quadril?.toString() || null,
      incisao_data_quadril: dados?.incisao_data_quadril?.toString() || null,
      incisao_hora_quadril: dados?.incisao_hora_quadril?.toString() || null,
      profilaxia_tv_quadril: dados?.profilaxia_tv_quadril?.toString() || null,
      anticoagulacao_quadril: dados?.anticoagulacao_quadril?.toString() || null,
      dor_quadril: dados?.dor_quadril?.toString() || null,
      sentar_data_quadril: dados?.sentar_data_quadril?.toString() || null,
      sentar_hora_quadril: dados?.sentar_hora_quadril?.toString() || null,
      deambular_data_quadril: dados?.deambular_data_quadril?.toString() || null,
      deambular_hora_quadril: dados?.deambular_hora_quadril?.toString() || null,
      covid_quadril: dados?.covid_quadril?.toString() || null,
      saida_motivo_quadril: dados?.saida_motivo_quadril?.toString() || null,
      saida_data_quadril: dados?.saida_data_quadril?.toString() || null,
      saida_hora_quadril: dados?.saida_hora_quadril?.toString() || null,
      paliativo_quadril: dados?.paliativo_quadril?.toString() || null,
      reinternacao_quadril: dados?.reinternacao_quadril?.toString() || null,
      reinternacao_motivo_quadril:
        dados?.reinternacao_motivo_quadril?.toString() || null,
      infeccao_quadril: dados?.infeccao_quadril?.toString() || null,
      infeccao_data_quadril: dados?.infeccao_data_quadril?.toString() || null,
      obito_seg_quadril: dados?.obito_seg_quadril?.toString() || null,
    },
    validationSchema: LcQuadrilSchema,

    onSubmit: async values => {
      if (id) {
        const payload = {
          ...values,
          // ...dados,
        };

        // limpa erros
        dispath(
          actions.quadrilFailure({
            errorData: null,
          })
        );

        return dispath(
          actions.quadrilUpdateRequest({
            data: payload,
            id: id,
            periodo: location?.state?.periodo,
          })
        );
      }
      dispath(
        actions.quadrilRequest({
          data: values,
          periodo: location?.state?.periodo,
        })
      );
    },
  });

  const callHandleSubmit = useCallback(() => {
    Swal.fire(modalConfirm).then(result => {
      if (result.value) {
        formik.handleSubmit();
      }
    });
  }, []); ////////////////////

  /*/////////////////////
   */ useEffect(() => {
    // limpa erros
    dispath(
      actions.quadrilFailure({
        errorData: null,
      })
    );
  }, []);

  useEffect(() => {
    if (location?.state?.id) {
      dispath(
        actions.quadrilGetRequest({
          id: location?.state?.id,
        })
      );
    }
  }, [location?.state]);

  useEffect(() => {
    if (id && careLineData) {
      setDados(careLineData);
    }
  }, [careLineData]);

  // Lógica de Ramificação

  const [exibeEscolaridade, setExibeEscolaridade] = useState(false);
  const [exibeSeguimento, setExibeSeguimento] = useState(false);
  const [exibeReinternacao, setExibeReinternacao] = useState(false);
  const [exibeDataDiagnostico, setExibeDataDiagnostico] = useState(false);

  const handleExibeEscolaridade = useCallback(
    value => {
      if (value == null || value == '') {
        setExibeEscolaridade(false);
        formik.setFieldValue('escolaridade_quadril', null);
      } else {
        setExibeEscolaridade(true);
      }
      formik.setFieldValue('meem_quadril', onlyNumbers(value)?.toString());
    },
    [formik]
  );

  const handleExibeSeguimento = useCallback(
    (name, value) => {
      if (name == 'saida_motivo_quadril') {
        if (value == 2 || value == null) {
          setExibeSeguimento(false);
          setExibeReinternacao(false);
          formik.setFieldValue('reinternacao_motivo_quadril', null);
          formik.setFieldValue('reinternacao_quadril', null);
          formik.setFieldValue('obito_seg_quadril', null);
        } else {
          setExibeSeguimento(true);
        }
        formik.setFieldValue('saida_motivo_quadril', value?.toString());
      }
    },
    [formik]
  );

  const handleExibeReinternacao = useCallback(
    (name, value) => {
      if (name == 'reinternacao_quadril') {
        if (value == 1) {
          setExibeReinternacao(true);
        } else {
          setExibeReinternacao(false);
          formik.setFieldValue('reinternacao_motivo_quadril', null);
        }
      }
      formik.setFieldValue(name, value?.toString());
    },
    [formik]
  );

  const handleExibeDataDiagnostico = useCallback(
    (name, value) => {
      if (name == 'infeccao_quadril') {
        if (value == 1) {
          setExibeDataDiagnostico(true);
        } else {
          setExibeDataDiagnostico(false);
          formik.setFieldValue('infeccao_data_quadril', null);
        }
        formik.setFieldValue('infeccao_quadril', value?.toString());
      }
    },
    [formik]
  );

  useEffect(() => {
    if (dados) {
      if (dados?.meem_quadril !== null && dados?.meem_quadril !== '') {
        setExibeEscolaridade(true);
      }
      handleExibeSeguimento(
        'saida_motivo_quadril',
        dados?.saida_motivo_quadril
      );
      handleExibeReinternacao(
        'reinternacao_motivo_quadril',
        dados?.reinternacao_motivo_quadril
      );
      handleExibeDataDiagnostico('infeccao_quadril', dados?.infeccao_quadril);
    }

    console.log('dados useEffect', dados);
  }, [dados]);

  // Fim da Lógica de Ramificação

  // Reset Button
  const [isLoaded, setIsloaded] = useState(false);

  const handleResetGroup = useCallback(
    group => {
      group.map(item => {
        formik.setFieldValue(`${item.name}`, '');
        handleExibeSeguimento(`${item.name}`, null);
        handleExibeReinternacao(`${item.name}`, null);
        handleExibeDataDiagnostico(`${item.name}`, null);
      });
    },
    [formik]
  );

  useEffect(() => {
    setTimeout(() => {
      setIsloaded(true);
    }, 2000);
  }, []);

  useEffect(() => {
    scrollPageTo(75);
  }, []);

  useEffect(() => {
    const keyErrors = Object.keys(formik.errors);
    if (keyErrors.length > 0 && formik.isSubmitting) {
      setTimeout(() => {
        const errorElement = document.querySelector(`[name="${keyErrors[0]}"]`);
        if (errorElement)
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [formik.submitCount, formik.errors]);

  const getErrosPdf = useCallback(() => {
    const { indicador } = location.state;
    history.push({
      pathname: `/area-de-suporte`,
      state: {
        searchBy: `${getTitleIndicador(indicador)}`,
      },
    });
  }, []);

  return (
    <>
      <Breadcumbs
        path="artropatia_de_quadril"
        pathTitle="Adicionar Indicadores de Linhas de Cuidado / Quadril"
      />
      <PageTitle>
        <div>
          <ButtonBack />
          <span ref={firstFocus}>Ficha de coleta</span>
        </div>

        {errorData?.fields && isLoaded && (
          <button className="errorButton" type="button" onClick={getErrosPdf}>
            <IoMdHelpCircle size={16} color="#FFF" />
            Documentação de erros
          </button>
        )}
      </PageTitle>

      {loading ? (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      ) : (
        <BoxContent>
          <div className="title">
            <h2>Preencha abaixo as informações:</h2>
          </div>

          <div className="BoxErros">
            {errorData?.fields && (
              <ExceptionsForm
                lc="artropatia_de_quadril"
                exceptions={errorData?.fields}
              />
            )}
          </div>

          <Content>
            <form onSubmit={formik.handleSubmit} method="post">
              {/* Linha de Cuidado, Competência e Dados Gerais */}
              {/* Dados da doença e do tratamento */}
              <BoxForm>
                <Row>
                  <Col span={24}>
                    <BoxInput>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Linha de Cuidado
                        </TitleSection>
                        <input
                          type="text"
                          name="indicadorNome"
                          defaultValue={location?.state?.indicadorNome || ''}
                          disabled
                        />
                      </Col>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Competência
                        </TitleSection>
                        <input
                          type="text"
                          name="periodo"
                          defaultValue={location?.state?.periodo}
                          disabled
                        />
                      </Col>
                    </BoxInput>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Col span={12}>
                    <TitleSection>{'>'} Dados Gerais do paciente</TitleSection>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Row>
                      <Col span={12} className="item">
                        <Input
                          name="num_registro_quadril"
                          label="1) Número do registro"
                          type="text"
                          // placeholder="Número do registro"
                          value={
                            formik.values.num_registro_quadril || numeroPaciente
                          }
                          hasError={
                            formik.errors.num_registro_quadril &&
                            formik.touched.num_registro_quadril
                              ? formik.errors.num_registro_quadril
                              : ''
                          }
                          maxLength={5}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'num_registro_quadril',
                              onlyNumbers(target.value)
                            );
                          }}
                        />
                      </Col>

                      <Col span={12} className="item">
                        <Row>
                          <Col span={12}>
                            <Label>2{')'} Sexo</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[{ name: 'sexo_quadril' }]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput>
                          <Col span={12}>
                            <BoxRadios
                              active={formik.values.sexo_quadril === '1'}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name="sexo_quadril"
                                value={formik.values.sexo_quadril}
                                checked={formik.values.sexo_quadril === '1'}
                                onChange={() =>
                                  formik.setFieldValue('sexo_quadril', '1')
                                }
                              >
                                Feminino
                              </Radio>
                            </BoxRadios>
                          </Col>
                          <Col>
                            <BoxRadios
                              active={formik.values.sexo_quadril === '0'}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name="sexo_quadril"
                                value={formik.values.sexo_quadril}
                                checked={formik.values.sexo_quadril === '0'}
                                onChange={() =>
                                  formik.setFieldValue('sexo_quadril', '0')
                                }
                              >
                                Masculino
                              </Radio>
                            </BoxRadios>
                          </Col>
                        </BoxInput>
                      </Col>
                    </Row>
                  </Col>

                  <Col span={24}>
                    <Row>
                      <Col span={12} className="item">
                        <DadoFaltantes
                          title="3) Data de nascimento"
                          name="dn_quadril"
                          formik={formik}
                          hasError={
                            formik.errors.dn_quadril && formik.submitCount > 0
                              ? formik.errors.dn_quadril
                              : ''
                          }
                        />
                      </Col>

                      <Col span={12} className="item">
                        {conveniosPaciente.map(item => (
                          <RadioInputFlex
                            key={`${item.id}-${item.name}`}
                            item={item}
                            formik={formik}
                          />
                        ))}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </BoxForm>
              <hr />

              {/* > Dados da doença e do tratamento */}

              <Row>
                <Col span={12}>
                  <TitleSection>
                    {'>'} Dados da doença e tratamento
                  </TitleSection>
                </Col>
                <Col span={12}>
                  {isLoaded && (
                    <ButtonReset
                      resetGroup={[...comorbidades]}
                      handleResetGroup={handleResetGroup}
                    />
                  )}
                </Col>
              </Row>

              <Row>
                <Row>
                  <h4>5{')'} Comorbidades</h4>
                </Row>
                <Col span={24}>
                  <BoxInput>
                    {comorbidades.map(item => (
                      <Col span={12}>
                        <Row>
                          <Label>{item.label}</Label>
                          <BoxInput key={item.id}>
                            {item.opcoes.map(opcao => (
                              <Col span={12} key={opcao.id}>
                                <BoxRadios
                                  active={
                                    formik.values[item.name] === opcao.value
                                  }
                                  style={{ maxWidth: '100%' }}
                                >
                                  <Radio
                                    name={item.name}
                                    value={formik.values[opcao.value]}
                                    checked={
                                      formik.values[item.name] === opcao.value
                                    }
                                    onChange={() =>
                                      formik.setFieldValue(
                                        `${item.name}`,
                                        opcao.value
                                      )
                                    }
                                  >
                                    {opcao.descricao}
                                  </Radio>
                                </BoxRadios>
                              </Col>
                            ))}
                          </BoxInput>
                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}
                        </Row>
                      </Col>
                    ))}
                  </BoxInput>
                </Col>
              </Row>
              <hr />
              {/* Pontuação no escore de HOOS-PS no pré-operatório */}
              <BoxForm>
                <Row>
                  <Col span={24}>
                    <BoxInput>
                      <Input
                        name="hoos_quadril"
                        label="6) Pontuação no escore de HOOS-PS no pré-operatório"
                        type="text"
                        // placeholder="Pontuação no escore de HOOS-PS no pré-operatório"
                        value={formik.values.hoos_quadril}
                        hasError={
                          (formik.errors.hoos_quadril &&
                            formik.touched.hoos_quadril) ||
                          formik.submitCount > 0
                            ? formik.errors.hoos_quadril
                            : ''
                        }
                        onChange={({ target }) => {
                          formik.setFieldValue(
                            'hoos_quadril',
                            onlyNumbers(target.value)
                          );
                        }}
                      />
                    </BoxInput>
                  </Col>
                </Row>
              </BoxForm>
              <hr />

              <BoxForm>
                <Row>
                  <Col span={12} />
                  <Col span={12}>
                    {isLoaded && (
                      <ButtonReset
                        resetGroup={[...dependencia]}
                        handleResetGroup={handleResetGroup}
                      />
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    {dependencia.map(item => (
                      <BoxInput>
                        <RadioInput
                          key={`${item.id}-${item.name}`}
                          item={item}
                          formik={formik}
                        />
                      </BoxInput>
                    ))}
                  </Col>
                </Row>
              </BoxForm>

              {/* Pontuação no MEEM pré-operatório */}
              <BoxForm>
                <Row>
                  <Col span={24}>
                    <Row>
                      <BoxInput>
                        <Input
                          name="meem_quadril"
                          label="8) Pontuação no MEEM pré-operatório"
                          type="text"
                          // placeholder='Pontuação no MEEM pré-operatório'
                          value={formik.values.meem_quadril}
                          hasError={
                            (formik.errors.meem_quadril &&
                              formik.touched.meem_quadril) ||
                            formik.submitCount > 0
                              ? formik.errors.meem_quadril
                              : ''
                          }
                          onChange={({ target }) => {
                            handleExibeEscolaridade(onlyNumbers(target.value));
                          }}
                        />
                      </BoxInput>
                    </Row>
                  </Col>
                </Row>
              </BoxForm>
              <hr />

              {exibeEscolaridade && (
                <>
                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        <Row>
                          <BoxInput>
                            <Input
                              name="escolaridade_quadril"
                              label="9) Escolaridade em anos de estudo"
                              type="text"
                              // placeholder='Escolaridade em anos de estudo'
                              value={formik.values.escolaridade_quadril}
                              hasError={
                                (formik.errors.escolaridade_quadril &&
                                  formik.touched.escolaridade_quadril) ||
                                formik.submitCount > 0
                                  ? formik.errors.escolaridade_quadril
                                  : ''
                              }
                              onChange={({ target }) => {
                                formik.setFieldValue(
                                  'escolaridade_quadril',
                                  onlyNumbers(target.value)
                                );
                              }}
                            />
                          </BoxInput>
                        </Row>
                      </Col>
                    </Row>
                  </BoxForm>
                  <hr />
                </>
              )}

              <BoxForm>
                <Row>
                  <Col span={24}>
                    {internacaoEPolitrauma.map(item => (
                      <BoxInput>
                        <RadioInput
                          key={`${item.id}-${item.name}`}
                          item={item}
                          reset
                          formik={formik}
                        />
                      </BoxInput>
                    ))}
                  </Col>
                </Row>
              </BoxForm>

              <BoxForm>
                <Row>
                  <h4>
                    12{')'} Data e hora da chegada do paciente no hospital
                  </h4>
                </Row>
                <Row>
                  {dataEHoraChegada.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </BoxForm>

              <BoxForm>
                <Row>
                  <h4>13{')'} Data e hora da admissão no centro cirúrgico</h4>
                </Row>
                <Row>
                  {dataEHoraAdmissao.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </BoxForm>

              <BoxForm>
                <Row>
                  <h4>
                    14{')'} Data e hora da administração de antibioticoterapia
                    profilática
                  </h4>
                </Row>
                <Row>
                  {dataEHoraAntibiotico.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        firstReason="Dado faltante"
                        secondReason="Não realizada, pois o paciente já estava em uso de antibioticoterapia"
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </BoxForm>

              <BoxForm>
                <Row>
                  <h4>15{')'} Data e hora da incisão cirúrgica</h4>
                </Row>
                <Row>
                  {dataEHoraIncisao.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </BoxForm>

              <BoxForm>
                <Row>
                  <Col span={24}>
                    {profilaxiaECoagulacao.map(item => (
                      <BoxInput>
                        <RadioInput
                          key={`${item.id}-${item.name}`}
                          item={item}
                          reset
                          formik={formik}
                        />
                      </BoxInput>
                    ))}
                  </Col>
                </Row>
              </BoxForm>

              <BoxForm>
                <Row>
                  <h4>
                    19{')'} Data e hora do primeiro momento em que o paciente
                    ficou sentado após a cirurgia
                  </h4>
                </Row>
                <Row>
                  {dataEHoraMomentoSentar.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        firstReason="Dado faltante"
                        secondReason="Não se aplica - paciente não sentou após cirurgia"
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </BoxForm>

              <BoxForm>
                <Row>
                  <h4>
                    20{')'} Data e hora do primeiro momento em que o paciente
                    deambulou após a cirurgia
                  </h4>
                </Row>
                <Row>
                  {dataEHoraMomentoDeambular.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        firstReason="Dado faltante"
                        secondReason="Não se aplica - paciente não deambulou após cirurgia"
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </BoxForm>

              {/* <BoxForm> */}

              <BoxForm>
                <Row>
                  <Col span={12}>
                    <TitleSection>{'>'} Dados da saída</TitleSection>
                  </Col>
                </Row>
                <BoxForm>
                  <Row>
                    <Col span={24}>
                      {covidQuadril.map(item => (
                        <Row>
                          <Row>
                            <Col span={12}>
                              <Label>{item.label}</Label>
                            </Col>
                            <Col span={12}>
                              {isLoaded && (
                                <ButtonReset
                                  resetGroup={[...covidQuadril]}
                                  handleResetGroup={handleResetGroup}
                                />
                              )}
                            </Col>
                          </Row>
                          <BoxInput key={item.id}>
                            {item.opcoes.map(opcao => (
                              <Col key={opcao.id}>
                                <BoxRadios
                                  active={
                                    formik.values[item.name] === opcao.value
                                  }
                                  style={{ maxWidth: '100%' }}
                                >
                                  <Radio
                                    name={item.name}
                                    value={formik.values[opcao.value]}
                                    checked={
                                      formik.values[item.name] === opcao.value
                                    }
                                    onChange={() =>
                                      formik.setFieldValue(
                                        `${item.name}`,
                                        opcao.value
                                      )
                                    }
                                  >
                                    {opcao.descricao}
                                  </Radio>
                                </BoxRadios>
                              </Col>
                            ))}
                          </BoxInput>

                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}
                        </Row>
                      ))}
                    </Col>
                  </Row>
                </BoxForm>

                <hr />
                <Row>
                  {motivoSaida.map(item => (
                    <Row>
                      <Row>
                        <Col span={12}>
                          <Label>{item.label}</Label>
                        </Col>
                        <Col span={12}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...motivoSaida]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      <BoxInput key={item.id}>
                        {item.opcoes.map(opcao => (
                          <Col span={12} key={opcao.id}>
                            <BoxRadios
                              active={formik.values[item.name] === opcao.value}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name={item.name}
                                value={formik.values[opcao.value]}
                                checked={
                                  formik.values[item.name] === opcao.value
                                }
                                onChange={() =>
                                  handleExibeSeguimento(item.name, opcao.value)
                                }
                              >
                                {opcao.descricao}
                              </Radio>
                            </BoxRadios>
                          </Col>
                        ))}
                      </BoxInput>

                      {formik.errors[item.name] && formik.submitCount > 0 ? (
                        <ErrorField message={formik.errors[item.name]} />
                      ) : null}
                    </Row>
                  ))}
                </Row>
              </BoxForm>

              {/* Data e Hora Saída */}
              <BoxForm>
                <Row>
                  <h4>23{')'} Data e hora da saída</h4>
                </Row>
                <Row>
                  {dataEHoraSaida.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </BoxForm>
              {/* Seguimento */}
              <BoxForm>
                <Row>
                  {/* {seguimento.map(item => ( */}
                  {confortoPaliativo.map(item => (
                    <Row>
                      <Row>
                        <Col span={12}>
                          <Label>{item.label}</Label>
                        </Col>
                        <Col span={12}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...confortoPaliativo]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      <BoxInput key={item.id}>
                        {item.opcoes.map(opcao => (
                          <Col span={12} key={opcao.id}>
                            <BoxRadios
                              active={formik.values[item.name] === opcao.value}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name={item.name}
                                value={formik.values[opcao.value]}
                                checked={
                                  formik.values[item.name] === opcao.value
                                }
                                onChange={() =>
                                  formik.setFieldValue(
                                    `${item.name}`,
                                    `${opcao.value}`
                                  )
                                }
                              >
                                {opcao.descricao}
                              </Radio>
                            </BoxRadios>
                          </Col>
                        ))}
                      </BoxInput>

                      {formik.errors[item.name] && formik.submitCount > 0 ? (
                        <ErrorField message={formik.errors[item.name]} />
                      ) : null}
                    </Row>
                  ))}
                </Row>
              </BoxForm>
              <Row>
                <Col span={12}>
                  <TitleSection>{'>'} Seguimento</TitleSection>
                </Col>
              </Row>
              {exibeSeguimento && (
                <BoxForm>
                  <Row>
                    {pacienteReinternou.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...pacienteReinternou]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col span={12} key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    handleExibeReinternacao(
                                      item.name,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </Row>
                </BoxForm>
              )}

              {exibeReinternacao && (
                <BoxForm>
                  <Row>
                    <Col span={24}>
                      {reinternacaoQuadril.map(item => (
                        <BoxInput>
                          <RadioInput
                            key={`${item.id}-${item.name}`}
                            item={item}
                            reset
                            formik={formik}
                          />
                        </BoxInput>
                      ))}
                    </Col>
                  </Row>
                </BoxForm>
              )}

              <BoxForm>
                <Row>
                  <Col span={24}>
                    {apresentouInfeccao.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...apresentouInfeccao]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col span={12} key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    handleExibeDataDiagnostico(
                                      item.name,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </Col>
                </Row>
              </BoxForm>

              {exibeDataDiagnostico && (
                <BoxForm>
                  <Row>
                    {dataDiagnostico.map(item => (
                      <Col span={12} className="item" key={item.id}>
                        <DadoFaltantes
                          title={item.label}
                          name={item.name}
                          formik={formik}
                          hasError={
                            formik.errors[item.name] && formik.submitCount > 0
                              ? formik.errors[item.name]
                              : ''
                          }
                        />
                      </Col>
                    ))}
                  </Row>
                </BoxForm>
              )}

              {exibeSeguimento && (
                <BoxForm>
                  <Row>
                    {seguimentoReinternacao.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...seguimentoReinternacao]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col span={12} key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    formik.setFieldValue(
                                      `${item.name}`,
                                      `${opcao.value}`
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </Row>
                </BoxForm>
              )}

              <ButtonBox>
                <button type="button" onClick={callHandleSubmit}>
                  {loading ? 'Enviando dados...' : 'Salvar'}
                </button>
              </ButtonBox>
            </form>
          </Content>
        </BoxContent>
      )}
    </>
  );
};

FichadeColetaQuadril.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      indicador: PropTypes.string,
      indicadorNome: PropTypes.string,
      periodo: PropTypes.string,
    }),
  }).isRequired,
};

export default FichadeColetaQuadril;
